import { AitHeaderGroupData } from "aic";
import { headerRowPreProcess } from "./headerRowPreProcess";

/**
 * Normalise a header group.
 * If no row group is provided a default empty group is returned. If `false`
 * is provided `false` is returned unchanged. Otherwise the group is returned
 * with rows normalised and a generated aitid when missing.
 *
 * @param defaultCellWidth - Default width to apply to header cells
 * @param blank - Blank value used for creating default cells
 * @param columnIds - Column ids to use when creating or mapping cells
 * @param rg - Optional header group to normalise or false
 * @returns AitHeaderGroupData or false
 */
export const headerPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  rg?: AitHeaderGroupData<T> | false,
): AitHeaderGroupData<T> | false => {
  if (rg === undefined) {
    return { aitid: crypto.randomUUID(), rows: [], coreTrafficLight: "BlankNotEvaluated" };
  }
  if (rg === false) return false;
  return {
    ...rg,
    rows: headerRowPreProcess(defaultCellWidth, blank, columnIds, rg.rows),
    aitid: rg.aitid ?? crypto.randomUUID(),
  };
};
